import type { Locale } from '@change/config/locales';

import { useL10n } from './context';

export function useLocale(): Locale {
	return useL10n().locale;
}
